import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useFillApplicationAction } from '../../../../hooks/useFillApplicationAction';
import { selectActionUrl } from '../../../../selectors/landing';
import { EFillApplicationStickyButtonType } from '../types';

export const useFillApplicationButtonClick = (
  analyticEventKey: EFillApplicationStickyButtonType = EFillApplicationStickyButtonType.TOP,
) => {
  const { fillApplicationAction, isPending } = useFillApplicationAction();
  const masterButtonActionUrl = useSelector(selectActionUrl) as string;

  const handleClick = useCallback(
    () => void fillApplicationAction({ path: masterButtonActionUrl, analyticEventKey }),
    [analyticEventKey, masterButtonActionUrl, fillApplicationAction],
  );

  return { handleClick, isPending };
};
